import logo from './logo.svg';
import './App.css';
import AppRoutes from './Router';

function App() {
  return (
    <AppRoutes/>
  );
}

export default App;
